import { Injectable, OnInit } from '@angular/core';
import {
  API_METHODS,
  API_URL,
  ASSIGNMENT_GRID_URL,
  OperationType,
} from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { environment } from 'src/environments/environment';
import { FormDataService } from '../../base-data-services/form-data.service';
import { RegisterModel } from 'common/models/page-models/register/register-final-model/register-data-model';
import { DataModel } from 'common/models/utility-models/base-model';

@Injectable({
  providedIn: 'root',
})
export class RegisterFormDataService extends FormDataService<RegisterModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.register, http, ss);
  }

  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.registerOtp,
      method: API_METHODS.post,
    };
    return edit;
  }

  //   override modifyPostModel(formModel: any, dataModel: any) {
  //     const data = {
  //         otp: formModel.otp,
  //         email: dataModel.email
  //     }
  //     return data;
  // }

  // const data = {
  //           otp: formModel.otp,
  //           email: dataModel.email
  //       }

  postDataToApi(url: string, body: any): Promise<any> {
    // console.log(body);
    return new Promise<any>((resolve, reject) => {
      this.apiService
        .postData(url, this.convertFormData(body))
        .then((res) => {
          resolve(res);
        })

        .catch((err) => {
          reject(err);
        });
    });
  }

  override modifyAPIResponse(response: any) {
    // console.log(response, 'hello response');
    return response['detail'];
  }

  override modifyPostModel(formModel, dataModel) {
    // console.log(formModel, dataModel);
    // formModel.step4.anyScholarship === '' ?'false': formModel.step4.anyScholarship
    let merged = {
      ...formModel.step1,
      ...formModel.step2,
      ...formModel.step3,
      ...formModel.step4,
    };
    // console.log(merged,formModel.step4,'Asdfgh');
    return this.ss.removeEmptyOrNullValuesAndConvertFields(merged);
  }

  override afterPostData(
    model: RegisterModel,
    response
  ): Promise<RegisterModel> {
    return new Promise<RegisterModel>((resolve, reject) => {
      if (response) {
        // this.ss.setLoginData(modifiedResponse);
        // console.log(response.details.id);
        model.studentApplicationId = response.details.applicationId;
        // console.log(model.studentApplicationId)
      }
      resolve(this.transformAPIData(model));
    }).catch((err) => {
      console.log(err);
      throw err;
    });
  }

  createInstance(): RegisterModel {
    return new RegisterModel();
  }
}
